import styled from 'styled-components';
import { motion } from 'framer-motion';

const SideNavBodyContainerStyled = styled.div`
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  top: 88px;
  width: 100%;
  z-index: 98;
  height: 100%;
`;

const SideNavButtonStyled = styled.button.attrs(() => ({
  type: 'button',
}))`
  width: 17px;
  height: 13px;
  background: unset;
  border: unset;
  padding: unset;
  margin: unset;
  cursor: pointer;

  @media (min-width: 769px) {
    display: none;
  }
`;

const SideNavBodyContentContainerStyled = styled(motion.nav)`
  overflow-y: auto;
  width: 100%;
  height: 100%;
  position: absolute;
  right: 0;
  z-index: 99;
`;

const duration = 0.5;
const AnimationTransitions = {
  initial: {
    opacity: 1,
    x: 600,
  },
  enter: {
    opacity: 1,
    x: 0,
    transition: {
      duration,
      ease: [0.55, 0.085, 0.68, 0.53],
      delay: 0,
    },
  },
  exit: {
    opacity: 1,
    x: 600,
    transition: {
      duration,
      ease: [0.55, 0.085, 0.68, 0.53],
      delay: 0,
    },
  },
};

export {
  SideNavBodyContainerStyled,
  SideNavBodyContentContainerStyled,
  SideNavButtonStyled,
  AnimationTransitions,
};
